var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"location-panoram"},[_c('v-img',{staticClass:"d-sm-none",attrs:{"src":require("@/assets/Location/location-panoram/panoram-xs.png")}}),_c('v-img',{staticClass:"d-none d-sm-block",attrs:{"src":require("@/assets/Location/location-panoram/panoram.png")}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }